import { EntTerritorialUnitsFilter } from "features/territorialUnit/model/territorialUnitsFilter";
import { EntTerritorialsUnits } from "features/territorialUnit/model/territorialUnits";
import { PagedResponse } from "shared/model/api";
import { handbooksApi } from "features/handbookList/api/handbooksListApi";

export const territorialUnitsApi = handbooksApi.injectEndpoints({
  endpoints: (builder) => ({
    getTerritorialUnitsList: builder.query<
      PagedResponse<EntTerritorialsUnits>,
      EntTerritorialUnitsFilter
    >({
      query: (filter) => ({
        url: `/territorial-unit/get-all`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),
    getTerritorialUnitsShortList: builder.query<
      PagedResponse<EntTerritorialsUnits>,
      EntTerritorialUnitsFilter
    >({
      query: (filter) => ({
        url: `/territorial-unit/get-all/short`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),
    getTerritorialUnitsGetpolygonsList: builder.query<
      PagedResponse<EntTerritorialsUnits>,
      EntTerritorialUnitsFilter
    >({
      query: (filter) => ({
        url: `/territorial-unit/get-all/polygons`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetTerritorialUnitsListQuery,
  useLazyGetTerritorialUnitsShortListQuery,
  useGetTerritorialUnitsGetpolygonsListQuery,
} = territorialUnitsApi;
